var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.classList,style:(_vm.styleObject),attrs:{"name":_vm.options.name,"value":_vm.value},on:{"mouseup":function($event){$event.stopPropagation();},"click":_vm.clickHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }